<template>
  <div class="genres">
    <div v-for="genre in genres" :key="genre.id">
      <div class="genre">
        <div class="name">{{ genre | genreName }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import genres from '../../public/mocks/genres.json';
export default {
  name: 'Genres',
  props: {
    genres: {
      type: Array,
      default: () => [],
    },
  },
  filters: {
    genreName: value => {
      const genre = genres.find(genre => genre.id === value);
      return genre.translation;
    },
  },
};
</script>

<style lang="scss">
.genres {
  display: flex;
  .genre {
    padding: 4px 8px;
    border-radius: 6px;
    border: 1px solid #ccc;
    margin-right: 6px;
  }
}
</style>
